import { render, staticRenderFns } from "./ManualCompraDiretaComprador.vue?vue&type=template&id=248a326e&scoped=true"
import script from "./ManualCompraDiretaComprador.vue?vue&type=script&lang=js"
export * from "./ManualCompraDiretaComprador.vue?vue&type=script&lang=js"
import style0 from "./ManualCompraDiretaComprador.vue?vue&type=style&index=0&id=248a326e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248a326e",
  null
  
)

export default component.exports